export default __webpack_public_path__ + "static/maax-webfont-aedfee2f0d5d75b0c62fea543b108c21.woff";